<template>

  <div class="integration-fields">

    <div
      v-for="field in fields"
      :key="field.key"
      class="form-group">

      <label>
        {{ field.label || field.key }}
        <span
          v-if="field.required"
          class="text-danger">*</span>
      </label>

      <!--select-->
      <select
        v-if="field.type === 'select'"
        class="form-control"
        :disabled="disabled"
        :value="value[field.key]"
        @change="change(field, $event.target.value)">
        <option :value="null">{{ $t('Select') }}</option>
        <option
          v-for="option in field.options"
          :key="option.value"
          :value="option.value">{{ option.label }}</option>
      </select>

      <!--radio-->
      <div v-else-if="field.type === 'radio'">
        <div
          v-for="option in field.options"
          :key="option.value"
          class="form-check">
          <input
            class="form-check-input"
            type="radio"
            :id="`${field.key}_${option.value}`"
            :disabled="disabled"
            :value="option.value"
            :checked="value[field.key] === option.value"
            @change="change(field, option.value)">
          <label
            class="form-check-label"
            :for="`${field.key}_${option.value}`">{{ option.label }}</label>
          <p
            v-if="option.help"
            class="text-muted mb-0">{{ option.help }}</p>
        </div>
      </div>

      <!--checkbox (booleano)-->
      <div
        v-else-if="field.type === 'checkbox'"
        class="form-check">
        <input
          class="form-check-input"
          type="checkbox"
          :id="field.key"
          :disabled="disabled"
          :checked="!!value[field.key]"
          @change="change(field, $event.target.checked)">
        <label
          class="form-check-label"
          :for="field.key">{{ field.placeholder || field.label }}</label>
      </div>

      <!--longtext-->
      <textarea
        v-else-if="field.type === 'longtext'"
        class="form-control"
        rows="3"
        :disabled="disabled"
        :placeholder="field.placeholder"
        :value="value[field.key]"
        @input="change(field, $event.target.value)"></textarea>

      <!--shorttext / number / demais tipos-->
      <input
        v-else
        class="form-control"
        :type="field.type === 'number' ? 'number' : 'text'"
        :disabled="disabled"
        :maxlength="field.maxLength || 255"
        :placeholder="field.placeholder"
        :value="value[field.key]"
        @input="change(field, $event.target.value)">

      <small
        v-if="field.help"
        class="text-muted d-block">{{ field.help }}</small>

      <ValidateMessage :error="errors[field.key]" />

    </div>

  </div>

</template>

<script>
export default {
  name: 'IntegrationFields',
  props: {
    fields: {
      type: Array,
      default: () => []
    },
    value: {
      type: Object,
      default: () => ({})
    },
    errors: {
      type: Object,
      default: () => ({})
    },
    disabled: {
      type: Boolean,
      default: false
    },
    autofocus: {
      type: Boolean,
      default: false
    }
  },
  mounted () {
    // foca o primeiro campo do schema (usado no modal de conexão)
    if (!this.autofocus) return
    const first = this.$el.querySelector('input, select, textarea')
    if (first) first.focus()
  },
  methods: {
    /*
    change
    emite o objeto completo para funcionar com v-model no componente pai
    */
    change (field, value) {
      const data = Object.assign({}, this.value)
      data[field.key] = field.type === 'number' && value !== '' ? Number(value) : value
      this.$emit('input', data)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Integrations/connectors/IntegrationFields.vue